<script setup>
import {computed, inject, ref} from "vue";
//import functions
//import components
import {FloatLabel, Dialog, Textarea} from "primevue";
import {Icon} from "@iconify/vue";
//import stores
import {useUserStore} from "@/stores/user.js";
//import composables
import {useBreakpoint} from "@/composables/useBreakpoint.js";
import {useLoadingFlags} from "@/composables/useLoadingFlags.js";
import {useToast} from "primevue/usetoast";

//stores
const userStore = useUserStore();

//loading flags
const {
  saving,
  setSaving,
} = useLoadingFlags()

//composables
const {isXL} = useBreakpoint();
const toast = useToast();

//emits
const emit = defineEmits(['refresh', 'skipAndReject', 'reject']);

//props
const props = defineProps({
  user: {
    type: Object,
    required: true
  },
  rejectLoading: {
    type: Boolean,
    default: false
  }
});

//injects
const visible = inject('isShowVerificationNoteModal')

//component variables
const notes = ref('')

//global functions
//component functions
const onSave = async () => {
  emit('reject', notes.value)
}

//hooks

//provides
</script>
<template>
  <Dialog v-model:visible="visible"
          :class="['max-w-3xl !border-0 !rounded-md !bg-[#0e1726]', isXL ? '' : 'w-full']"
          :position="isXL ? 'center' : 'bottom'"
          closable dismissable-mask draggable modal
          content-class="flex flex-col gap-4 overflow-hidden h-full w-full max-w-[calc(100vw-20px)] max-h-[calc(100vh-100px)]">
    <template #header>
      <div class="text-base py-3">
        Verification Note
      </div>
    </template>
    <template #closebutton="{closeCallback}">
      <div class="h-full w-[1px] bg-slate-700"></div>
      <button
          type="button"
          class="text-white-dark outline-none hover:text-red-500"
          @click="closeCallback"
      >
        <Icon icon="pajamas:close-xs"/>
      </button>
    </template>
    <div class="flex-1 flex flex-col gap-4 overflow-hidden pt-4 pb-1 text-xs 2xl:text-sm min-w-96 max-w-full">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 flex flex-col gap-0.5 text-xs 2xl:text-sm h-full">
          <FloatLabel variant="on" class="h-full">
            <Textarea v-auto-dir id="notes" v-model="notes" rows="5" style="resize: none"
                      class="!bg-transparent w-full rounded-md !text-xs 2xl:!text-sm !border-slate-700 h-full"/>
            <label for="notes" class="!bg-slate-900">Notes</label>
          </FloatLabel>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-3 select-none">
      <button @click="onSave"
              class="btn btn-outline-dark flex items-center justify-center gap-3 disabled:opacity-50 py-1">
        <Icon v-if="props.rejectLoading" icon="eos-icons:bubble-loading" height="20"/>
        Reject
      </button>
    </div>
  </Dialog>
</template>
<style></style>